<template>
<div id="wrapper" :key="valuekey">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.menu.curriculum.list.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputAddress" class="col-form-label">
                            {{$t('string.msg.curriculum.label.category.cnh')}}
                        </label>
                        
                            <select id="categoryCnh" v-model="filters.cnhCategory" class="form-control">
                            <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                                <option :value="item._id" v-bind:key="item._id" v-for="item in categoriesCnh">{{$t(item.name)}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputAddress" class="col-form-label">
                            {{$t('string.msg.curriculum.label.list.course.type')}}
                        </label>
                        <select id="categoryCnh" v-model="filters.additionalCourse" class="form-control">
                            <option :value="null" selected>{{$t('string.msg.select.selector.item')}}</option>
                            <option :value="item._id" v-bind:key="item._id" v-for="item in coursesTypes">{{$t(item.name)}}</option>
                        </select>
                    </div>
                </div><br>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <button @click="filter" class="btn btn-success w-30">{{$t('string.msg.form.btn.search')}}</button>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0" style="width: 20%">{{$t('string.msg.curriculum.table.header.name')}}</th>
                                <th class="border-top-0" style="width: 20%">{{$t('string.msg.curriculum.table.header.expirience')}}</th>
                                <th class="border-top-0" style="width: 20%">{{$t('string.msg.curriculum.table.header.cnh.category')}}</th>
                                <th class="border-top-0" style="width: 20%">{{$t('string.msg.curriculum.table.header.additional.course')}}</th>
                                <th class="border-top-0" style="width: 20%">{{$t('string.msg.curriculum.table.header.additional.date')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                            <tr v-if="item.status=='ACTIVE'">
                                <td>
                                    <span>
                                        {{item.trucker.firstName + ' ' + item.trucker.lastName }}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                          {{item.expirience }}
                                    </span>
                                </td>
                                 <td>
                                    <span>
                                        {{$t(item.cnhCategory)}}
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        {{$t(item.additionalCourse)}}
                                    </span>
                                </td>
                                <td v-if="item && item.date">
                                       {{new Date(item.date).toLocaleDateString()}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Controller from './CrtListCurriculum';

export default {
  name: 'ListTrucker',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        item: {},
        categoriesCnh:[
            {_id:"C",name:"Categoria C"},
            {_id:"D",name:"Categoria D"},
            {_id:"E",name:"Categoria E"}
        ],
        coursesTypes:[],
        filters: {
            cnhCategory: null,
            additionalCourse: null,
        },
        totalCurriculums:0
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
    Controller.init(this);
  },
}
</script>


